import styled from 'styled-components'

export const UploadContainer = styled.div`
  width: 100%;
  max-width: 400px;
`

export const UploadArea = styled.div<{ isDragActive?: boolean; hasFile?: boolean }>`
  border: 2px dashed ${props => props.isDragActive ? '#4F46E5' : '#E5E7EB'};
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background: ${props => props.isDragActive ? '#EEF2FF' : '#FFF'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: ${props => props.hasFile ? 'space-between' : 'center'};
  flex-direction: ${props => props.hasFile ? 'row' : 'column'};

  &:hover {
    border-color: #0090D3;
    background: #E6F4FB;
  }
`

export const HiddenInput = styled.input`
  display: none;
`

export const UploadIcon = styled.div`
color: #6B7280;
margin-bottom: ${(props:{hasFile?: boolean}) => props.hasFile ? '0' : '12px'};

svg {
  width: ${props => props.hasFile ? '24px' : '40px'};
  height: ${props => props.hasFile ? '24px' : '40px'};
  margin: 0 auto;
}
`

export const UploadContent = styled.div<{ hasFile?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${props => props.hasFile ? '12px' : '0'};
  flex-direction: ${props => props.hasFile ? 'row' : 'column'};
`

export const UploadText = styled.p<{ hasFile?: boolean }>`
color: #374151;
margin: 0;
font-size: 0.875rem;
${props => props.hasFile && `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`}
`

export const FileInfo = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FileName = styled.span`
  color: #374151;
  font-size: 0.875rem;
  margin-right: 8px;
`

export const RemoveButton = styled.button`
  background-color: #FD7477;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 50%;
`

export const FilePreviewContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 2px -2px #d1d5db;
  }
`

export const FilePreviewImage = styled.img`
  width: 100%;
  height: 12rem;
  border-radius: 1rem;
  object-fit: cover;
  background-color: #F4F4F4;
`

export const FilePreviewInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6B7280;
  font-weight: 500;
`

export const FullScreenModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: pointer;
`

export const FullScreenImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  cursor: default;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`